import { MatSnackBarConfig } from "@angular/material/snack-bar";

export const snackBarDefaultOptions: MatSnackBarConfig = {
  horizontalPosition: "right",
  verticalPosition: "top",
  panelClass: "ene-snack-bar",
  duration: 3000
};
